// src/components/programs/ProgramForm/helpers/formConstants.js

/**
 * Initial form data state
 */
export const INITIAL_FORM_DATA = {
    // Basic info
    title: { ar: '', en: '' },
    description: { ar: '', en: '' },
    agent_name: { ar: '', en: '' },
    cities: { ar: '', en: '' },
    start_date: '',
    end_date: '',
    durations_days: 0,
    durations_nights: 0,
    show_date_in_template: true,
    cover_image: null,
    cover_image_preview: '',

    // Pax types
    pax_types: [],

    // Itinerary
    itinerary: [],

    // Global discount
    global_discount: {
        type: 'zero',
        value: null,
        target: 'none',
    },

    // Upload states
    uploadingCoverImage: false,
    coverImageError: '',
    coverImageSuccess: '',
};

/**
 * Empty product structure template
 */
export const EMPTY_PRODUCT_TEMPLATE = {
    instance_id: null,
    product_snapshot: {
        product_id: null,
        title: { ar: '', en: '' },
        category: null,
        pricing_unit: 'per_person',
        pricing_code: 'per_person',
        original_price: 0,
        original_cost_price: 0,
        // ✅ إضافة original_sell_price
        original_sell_price: 0,
    },
    selected_supplier: null,
    selected_service: null,
    order: 1,
    pricing: {
        price: 0,
        cost_price: 0,
        custom_price: null,
        is_price_edited: false,
        discount_type: 'zero',
        discount_value: null,
        // ✅ إضافة original_sell_price في pricing أيضاً
        original_sell_price: 0,
    },
    dynamic_fields: {
        pickup_time: null,
        city: null,
        time: null,
        units: null,
        nights: null,
    },
    calculated: {
        final_price_per_unit: 0,
        final_cost_per_unit: 0,
        quantity: 0,
        total_price: 0,
        total_cost: 0,
    },
};

/**
 * Form steps configuration
 */
export const FORM_STEPS = [
    { id: 0, key: 'info' },
    { id: 1, key: 'data' },
    { id: 2, key: 'quotation' },
];

/**
 * Discount type options
 */
export const DISCOUNT_TYPES = {
    ZERO: 'zero',
    AMOUNT: 'amount',
    PERCENT: 'percent',
};

/**
 * Discount target options
 */
export const DISCOUNT_TARGETS = {
    NONE: 'none',
    SELL: 'sell',        // ✅ تطابق مع الباك إند
    COST: 'cost',        // ✅ تطابق مع الباك إند
    BOTH: 'both',        // ✅ تطابق مع الباك إند
};

/**
 * Pricing unit codes
 */
export const PRICING_UNIT_CODES = {
    PER_PERSON: 'per_person',
    PER_NIGHT: 'per_night',
    PER_UNIT: 'per_unit',
};

/**
 * Pricing unit ID to code mapping
 */
export const PRICING_UNIT_ID_MAP = {
    1: 'per_person',
    2: 'per_night',
    3: 'per_unit',
};
